













import { defineComponent } from '@vue/composition-api'
import { VPagination } from 'vuetify/lib'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-pagination',
  components: {
    VPagination
  },
  props: {
    total: { type: Number, required: true },
    totalPerPage: { type: Number, required: true },
    page: { type: Number, required: true },
    length: { type: Number, required: true },
    totalVisible: { type: Number, default: 7 }
  }
})
